function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 29,
  cy: 29,
  r: 29,
  fill: "#FEDEA7"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.4429 36.8463V27.19C34.4429 23.5397 31.9465 16.645 29 15.0003C26.5 14.5 28.0506 18.0244 27.2598 17.8209C23.1309 18.8834 20.0762 22.6752 20.0762 27.1902V36.9292C19.0022 37.4464 18.2397 38.5556 18.2397 39.8408H36.4685C36.4685 38.4817 35.6177 37.3197 34.4429 36.8463Z",
  fill: "#FFF9E4"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.4429 36.8462V27.1899C38.4429 22.6748 35.3884 18.8833 31.2598 17.8208C27.1309 18.8833 24.0762 22.6751 24.0762 27.1901V36.9291C23.0022 37.4462 22.2397 38.5555 22.2397 39.8407H40.4685C40.4685 38.4815 39.6177 37.3196 38.4429 36.8462Z",
  fill: "#FFB917"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30 43.0467C30.8635 42.6579 31.4661 41.7815 31.4661 40.762V39.8408H28.5337V40.762C28.5339 41.7815 29.1365 42.6579 30 43.0467Z",
  fill: "#FFB954"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35.3542 21.7278C35.3542 19.7149 36.6416 18.0075 38.4272 17.4026C37.9785 17.2506 37.499 17.167 37 17.167C34.5146 17.167 32.5 19.2089 32.5 21.7278C32.5 24.2467 34.5146 26.2886 37 26.2886C37.499 26.2886 37.9785 26.2052 38.4272 26.0531C36.6416 25.4483 35.3542 23.741 35.3542 21.7278Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.5 21.7281C41.5 19.7152 40.2126 18.0078 38.427 17.4028C36.6416 18.0078 35.354 19.7149 35.354 21.7281C35.354 23.7413 36.6416 25.4486 38.427 26.0533C40.2126 25.4486 41.5 23.7413 41.5 21.7281Z",
  fill: "#FF5D5D"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.0676 36.4435V27.1898C39.0676 26.9569 39.0591 26.7229 39.0437 26.49C40.8552 25.6883 42.1248 23.856 42.1248 21.728C42.1248 18.8639 39.8257 16.5338 36.9998 16.5338C35.6265 16.5338 34.3784 17.0851 33.4575 17.9796C32.8713 17.6819 32.2568 17.4431 31.6248 17.2657V16.6446C31.6248 15.1865 30.4541 14 29.0154 14H28.9841C27.5454 14 26.3748 15.1865 26.3748 16.6446V17.2133C21.9915 18.3562 18.7427 22.3959 18.7427 27.19V36.5527C17.6155 37.2519 16.9062 38.5022 16.9062 39.8406C16.9062 40.1905 17.186 40.4741 17.5312 40.4741H25.9087V40.7619C25.9087 42.4892 27.2954 43.8947 28.9998 43.8947C30.7041 43.8947 32.0908 42.4892 32.0908 40.7619V40.4741H40.4683C40.8135 40.4741 41.0933 40.1905 41.0933 39.8406C41.0933 38.4268 40.2947 37.1116 39.0676 36.4435ZM36.9998 17.8007C39.1365 17.8007 40.8748 19.5624 40.8748 21.728C40.8748 23.8936 39.1365 25.6554 36.9998 25.6554C34.863 25.6554 33.1248 23.8936 33.1248 21.728C33.1248 19.5624 34.863 17.8007 36.9998 17.8007ZM27.6248 16.6446V16.8901H30.3748V16.6446C30.3748 15.885 29.7649 15.2669 29.0154 15.2669H28.9841C28.2346 15.2669 27.6248 15.885 27.6248 16.6446ZM30.8408 40.7619C30.8408 41.7907 30.0149 42.6278 28.9998 42.6278C27.9846 42.6278 27.1587 41.7907 27.1587 40.7619V40.4741H30.8411V40.7619H30.8408ZM18.2366 39.2072H31.4658H39.7625C39.5588 38.4201 38.9861 37.7468 38.2117 37.4348C37.9739 37.339 37.8176 37.1057 37.8176 36.8461V27.1898C37.8176 27.0789 37.8149 26.9678 37.8108 26.8567C37.5466 26.8995 37.2759 26.9223 36.9998 26.9223C34.1738 26.9223 31.8748 24.5922 31.8748 21.728C31.8748 20.7237 32.1582 19.7856 32.6472 18.9901C31.4819 18.444 30.1985 18.157 28.905 18.157C23.9907 18.1572 19.9927 22.2093 19.9927 27.19V36.2956H26.1455C26.4907 36.2956 26.7705 36.5791 26.7705 36.929C26.7705 37.2789 26.4907 37.5625 26.1455 37.5625H19.5173C18.8765 37.9128 18.4146 38.5163 18.2366 39.2072Z",
  fill: "black"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.375 29.5986H42.0435C41.6982 29.5986 41.4185 29.8822 41.4185 30.2321C41.4185 30.582 41.6982 30.8655 42.0435 30.8655H44.375C44.7202 30.8655 45 30.582 45 30.2321C45 29.8822 44.7202 29.5986 44.375 29.5986Z",
  fill: "black"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.3856 27.2307C40.1417 27.4781 40.1417 27.8792 40.3856 28.1266C40.5076 28.2503 40.6675 28.3122 40.8275 28.3122C40.9876 28.3122 41.1475 28.2503 41.2696 28.1266L42.8885 26.4856C43.1326 26.2384 43.1326 25.8373 42.8885 25.5899C42.6446 25.3424 42.2488 25.3424 42.0047 25.5899L40.3856 27.2307Z",
  fill: "black"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.3124 32.3675C41.0682 32.1203 40.6725 32.1203 40.4286 32.3677C40.1844 32.6152 40.1847 33.0163 40.4288 33.2635L42.0038 34.8587C42.1259 34.9824 42.2855 35.0443 42.4454 35.0443C42.6056 35.0443 42.7655 34.9822 42.8876 34.8585C43.1315 34.611 43.1315 34.2099 42.8873 33.9627L41.3124 32.3675Z",
  fill: "black"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.5815 30.2238C16.5815 29.8739 16.3018 29.5903 15.9565 29.5903H13.625C13.2798 29.5903 13 29.8739 13 30.2238C13 30.5737 13.2798 30.8572 13.625 30.8572H15.9565C16.3018 30.8572 16.5815 30.5737 16.5815 30.2238Z",
  fill: "black"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.7303 28.1189C16.8524 28.2426 17.0123 28.3042 17.1722 28.3042C17.3321 28.3042 17.4922 28.2426 17.6141 28.1189C17.8582 27.8714 17.8582 27.4703 17.6141 27.2229L15.9952 25.5819C15.751 25.3347 15.3553 25.3347 15.1111 25.5819C14.8672 25.8293 14.8672 26.2304 15.1111 26.4779L16.7303 28.1189Z",
  fill: "black"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.5716 32.3601C17.3277 32.1124 16.9319 32.1124 16.6878 32.3599L15.1128 33.9551C14.8687 34.2023 14.8687 34.6034 15.1126 34.8508C15.2346 34.9746 15.3946 35.0364 15.5547 35.0364C15.7146 35.0364 15.8745 34.9746 15.9964 34.8511L17.5713 33.2558C17.8155 33.0084 17.8157 32.6073 17.5716 32.3601Z",
  fill: "black"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.6119 21.7597L36.772 21.5974V23.3881C36.772 23.738 37.0518 24.0216 37.397 24.0216C37.7422 24.0216 38.022 23.738 38.022 23.3881V20.0682C38.022 19.8119 37.8697 19.581 37.636 19.4828C37.4026 19.3848 37.1339 19.439 36.9549 19.6201L35.7278 20.8637C35.4839 21.1112 35.4839 21.5123 35.7278 21.7597C35.972 22.0069 36.3677 22.0069 36.6119 21.7597Z",
  fill: "black"
});

const SvgComponent = props => React.createElement("svg", _extends({
  width: 58,
  height: 58,
  viewBox: "0 0 58 58",
  fill: "none"
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);

export default __webpack_public_path__ + "static/media/notification-bell.42b499af.svg";
export { SvgComponent as ReactComponent };